import React from 'react';
import { SEOHead } from './components/SEOHead';
import { Hero } from './components/Hero';
import { Benefits } from './components/Benefits';
import { SocialProof } from './components/SocialProof';
import { FeaturedTools } from './components/FeaturedTools';
import { Footer } from './components/Footer';
function App() {
  return <div className="min-h-screen bg-white selection:bg-purple-100 selection:text-purple-900" data-id="element-0">
      <SEOHead data-id="element-1" />

      <header className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-slate-100" data-id="element-2">
        <div className="container mx-auto px-6 h-16 flex items-center justify-between" data-id="element-3">
          <a href="https://keyanalyzer.com/" className="text-xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-purple-600 to-blue-600" data-id="element-4">
            Keyanalyzer
          </a>
          <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-slate-600" data-id="element-5">
            <a href="https://keyanalyzer.com/#features" className="hover:text-slate-900 transition-colors" data-id="element-6">
              Features
            </a>
            <a href="https://keyanalyzer.com/#tools" className="hover:text-slate-900 transition-colors" data-id="element-7">
              Tools
            </a>
            <a href="https://keyanalyzer.com/#reviews" className="hover:text-slate-900 transition-colors" data-id="element-8">
              Reviews
            </a>
            <a href="https://keyanalyzer.com/#pricing" className="hover:text-slate-900 transition-colors" data-id="element-9">
              Pricing
            </a>
          </nav>
          <div className="flex items-center gap-4" data-id="element-10">
            <a href="https://keyanalyzer.com/login" className="text-sm font-medium text-slate-600 hover:text-slate-900 hidden sm:block" data-id="element-11">
              Log in
            </a>
            <a href="https://keyanalyzer.com/" className="px-4 py-2 text-sm font-semibold text-white bg-slate-900 rounded-full hover:bg-slate-800 transition-colors" data-id="element-12">
              Get Started
            </a>
          </div>
        </div>
      </header>

      <main data-id="element-13">
        <Hero data-id="element-14" />
        <Benefits data-id="element-15" />
        <SocialProof data-id="element-16" />
        <FeaturedTools data-id="element-17" />
      </main>

      <Footer data-id="element-18" />
    </div>;
}
export { App };